$('.profileAnswerButton').click(function (e) {
  e.preventDefault();

  const jobTitle = $(this).closest('header').children('h3').text();

  $('#uJobtitle').val(jobTitle);
});



// WEBPACK FOOTER //
// ./app/blocks/section-profile/section-profile.js